export default "__VITE_ASSET__BTCaeso1__"